export default __webpack_public_path__ + "static/media/chevron-double-left.babf1502.svg";